
















import { Component, Vue } from 'vue-property-decorator';

import NavBarRight from './NavBarRight.vue';

import mainStore from '@/store/main-store/MainStore';

@Component({
    name: 'NavBar',
    components: {
        NavBarRight,
    },
})
export default class NavBar extends Vue {
    private mainStore = mainStore.context(this.$store);

    private get totalProductsCar(): number {
        return this.mainStore.getters.totalProductsCar;
    }

    private get totalPriceCar(): number {
        return this.mainStore.getters.totalPriceCar;
    }

    private toHome(): void {
        this.$route.path === '/' ? null : this.$router.push('/');
    }
}
